import React from 'react';

interface LoadingSpinnerProps {
  isLoading: boolean;
  title?: string;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  isLoading, 
  title = 'Quase lá!', 
  message = 'Carregando, aguarde...' 
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-transparent mb-4"></div>
      <h2 className="text-white text-xl font-semibold mb-2">{title}</h2>
      <p className="text-white text-sm">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
